<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import CUSkeletonLoaderTextField from '@/components/CUSkeletonLoaderTextField.vue'

const props = defineProps({
  dense: { type: Boolean, default: false },
  skeletonLoader: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  tabIndex: { type: Number, default: null },
  isFinix: { type: Boolean, default: false }
})

const emit = defineEmits(['input'])

const attrs = useAttrs()

const listeners = computed(() => {
  return {
    ...attrs,
    input(event: InputEvent) {
      emit('input', event)
    }
  }
})
</script>

<template>
  <CUSkeletonLoaderTextField v-if="skeletonLoader" :label="$attrs.label" />
  <div v-else class="cu-text-field">
    <label v-if="$attrs.label">
      {{ $attrs.label }}
      <span v-if="required" class="text-error">*</span>
    </label>
    <slot name="label" />
    <v-text-field
      :dense="dense"
      :class="{ dense: dense }"
      v-bind="$attrs"
      solo
      :label="null"
      flat
      outlined
      :tabindex="tabIndex"
      v-on="listeners"
    >
      <template #append>
        <slot name="append" />
      </template>
    </v-text-field>
  </div>
</template>


<style lang="scss" scoped>
::v-deep .v-text-field {
  &.dense {
    .v-input__control {
      > .v-input__slot {
        min-height: 40px !important;
      }
    }
  }
}

::v-deep .v-input__control {
  .v-input__slot {
    padding: 0 12px !important;
  }
}
</style>
